module.exports = __webpack_public_path__ + "static/media/cartoon-preview.c8f57a61.svg";